
export const getParsedAccountPlans = (accountPlans = []) =>
  accountPlans.map(item => ({
    name: item.Name,
    uuid: item.Uuid,
  }));

export default () => {};



// WEBPACK FOOTER //
// ./src/reducers/organization/responseParser.js